'use client';

import { useRouter } from 'next/navigation';

import BaseModal from '@/components/modal/lib/BaseModal';
import Text from '@/components/common/Text/Text';
import Button from '@/components/common/Button/Button';
import { AMBASSADOR_SIGNUP_ROUTES } from '@/const/signup';
import { writeAmbassadorHandoffFromSignupState } from '@/util/ambassadorApplyDraft';
import type { SignupState } from '@/types/Signup';

import './BrandAmbassadorRedirectModal.style.scss';

type BrandAmbassadorRedirectModalProps = {
  /** Called when the user dismisses the modal to stay on the standard application */
  onClose: () => void;
  /**
   * Called on CTA click to take a one-shot snapshot of regular-apply state
   * (SignupContext + live Formik). Written to BA session draft, then navigate.
   * Not continuous BA monitoring of the regular form.
   */
  getRegularApplySnapshot: () => Partial<SignupState>;
};

function BrandAmbassadorRedirectModal(
  props: BrandAmbassadorRedirectModalProps
) {
  const { onClose, getRegularApplySnapshot } = props;
  const router = useRouter();

  return (
    <BaseModal
      className='BrandAmbassadorRedirectModal'
      onClose={onClose}
    >
      <Text
        className='BrandAmbassadorRedirectModal-title'
        variant='title-l'
        italic
      >
        Looks like you have a Brand Ambassador code!
      </Text>
      <Text
        className='BrandAmbassadorRedirectModal-copy'
        variant='text-m'
      >
        The code you entered is exclusively available through Vivrelle&apos;s
        Brand Ambassador program.
      </Text>
      <div className='BrandAmbassadorRedirectModal-buttons'>
        <Button
          onClick={() => {
            writeAmbassadorHandoffFromSignupState(getRegularApplySnapshot());
            onClose();
            router.push(AMBASSADOR_SIGNUP_ROUTES.APPLY);
          }}
        >
          Become An Ambassador
        </Button>
      </div>
    </BaseModal>
  );
}

export default BrandAmbassadorRedirectModal;
